<nb-card>
  <nb-card-body>
    <ngx-view-table-pagination-products
      [shopId]="shopId"
      [mode]="'loan'"
      (onSelectedProduct)="selected($event)"
      (onNewProduct)="onNewProduct()"
    >
    </ngx-view-table-pagination-products>
  </nb-card-body>
</nb-card>
